import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LayoutContext } from "../layout-context-container";

function AutoScrollActive() {
  const { setAutoScrollActive, autoScrollActive } = useContext(LayoutContext);
  const location = useLocation();
  
  useEffect(() => {
    setAutoScrollActive(true);

    return () => {
      setAutoScrollActive(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    let timeout;

    if (autoScrollActive) {
      timeout = setTimeout(() => {
        setAutoScrollActive(false);
      }, 1000);
    }

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoScrollActive]);

  return null;
}

export default AutoScrollActive;